module.exports = __webpack_public_path__ + "img/jh.a98b7270.png";